import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import appconst from "../../lib/appconst";

interface ReportCollectionCodeChangeState extends ListState<any> {}
class ReportCollectionCodeChange extends ListModule<
  ReportCollectionCodeChangeState,
  any,
  any
> {
  state = {
    totalCount: 0,
    currentPage: 0,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
  };
  actions = {
    async reportToReplace(
      context: ActionContext<ReportCollectionCodeChangeState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/CollectionCode/reportToReplace", {
        params: payload.data,
      });
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async export(
      context: ActionContext<ReportCollectionCodeChangeState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }export/exportCollectionCodesChanged${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
  };

  mutations = {
    setCurrentPage(state: ReportCollectionCodeChangeState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: ReportCollectionCodeChangeState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const reportCollectionCodeChangeStateModule = new ReportCollectionCodeChange();
export default reportCollectionCodeChangeStateModule;
